document.querySelectorAll('article.vacancy').forEach((vacancy) => {
	const criteria = vacancy.querySelector('.vacancy-criteria');

	if (criteria && criteria.textContent.trim() === '') {
		const footer = vacancy.querySelector('.vacancy-footer');
		if (footer) {
			footer.style.display = 'none'; // Hides the footer if criteria is empty
		}
	}
});
